export const SIDE_BAR_MINI_WIDTH = 48
